<template>
  <div>
    <div @click.stop="open = !open">
      <slot name="activator">
        <v-btn fab bottom right color="accent">
          <v-icon>Contact</v-icon>
        </v-btn>
      </slot>
    </div>

    <v-dialog scrollable v-model="open" width="400">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text"> Contact to {{ patient.firstname }} </v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea
                    outlined
                    label="Message"
                    auto-grow
                    v-validate="'required'"
                    :error-messages="errors.collect('message')"
                    data-vv-name="message"
                    v-model="Form.message"
                    clearable
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group label="Type" mandatory v-model="Form.type" row>
                    <v-flex xs12>
                      <v-radio
                        :disabled="!patient.user.tel && !patient.user.tel_confirmed"
                        label="SMS"
                        value="sms"
                      ></v-radio>
                    </v-flex>
                    <v-flex xs12>
                      <v-radio
                        :disabled="!patient.user.email && !patient.user.email_confirmed"
                        label="Email"
                        value="email"
                      ></v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-3 pr-5">
          <v-spacer></v-spacer>
          <v-btn text @click="(open = false), resetFormError(null, Form)">Cancel</v-btn>
          <v-btn color="primary" text :disabled="!Form.valid" @click="confirmToCreate">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import smsService from '../services/sms';
import emailService from '../services/email';

export default {
  mixins: [formMixin],
  props: {
    patient: {
      type: Object,
      default() {},
    },
  },
  data() {
    return {
      open: false,

      Form: new Forms({
        data: () => ({
          message: '',
          type: 'email',
        }),
      }),
    };
  },
  computed: {},
  watch: {},
  methods: {
    confirmToCreate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Send', 'Are you confirm to send?', {
              color: 'primary',
              submitText: 'Yes',
            })
            .then((confirm) => {
              if (confirm) this.sendMessage();
            });
        }
      });
    },
    sendMessage() {
      if (this.Form.type === 'sms') {
        smsService
          .send(this.patient.user.tel, this.Form.message)
          .then(() => {
            this.open = false;
            this.$emit('success');
            this.$notify({
              title: 'Success',
              text: `Send sms to ${this.patient.firstname} successfully.`,
              type: 'success',
            });
          })
          .catch((error) => {
            this.$notify({
              title: 'Error',
              text: `Failed to send SMS to ${this.patient.firstname}. Please try again.${
                error && error.message ? ' Error: ' + error.message : ''
              }`,
              type: 'error',
            });
            console.log(error);
          });
      } else if (this.Form.type === 'email') {
        emailService
          .send(this.patient.user.email, this.Form.message)
          .then(() => {
            this.open = false;
            this.$emit('success');
            this.$notify({
              title: 'Success',
              text: `Send email to ${this.patient.firstname} successfully.`,
              type: 'success',
            });
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              title: 'Error',
              text: `Failed to send email to ${this.patient.firstname}. Please try again.`,
              type: 'error',
            });
          });
      }
    },
  },
  mounted() {},
  components: {},
};
</script>
